import React from "react";
import { useNetworkQuality } from "../../hooks/useNetworkQuality";
import type { NetworkQualityLevel } from "../../hooks/useNetworkQuality";
import "./NetworkQualityIndicator.scss";

const TOTAL_BARS = 5;

const LEVEL_CONFIG: Record<NetworkQualityLevel, { label: string; activeBars: number; colorClass: string }> = {
  excellent: { label: "Excellent", activeBars: 5, colorClass: "nqi--excellent" },
  good:      { label: "Good",      activeBars: 4, colorClass: "nqi--good"      },
  fair:      { label: "Fair",      activeBars: 3, colorClass: "nqi--fair"      },
  poor:      { label: "Poor",      activeBars: 2, colorClass: "nqi--poor"      },
  critical:  { label: "Critical",  activeBars: 1, colorClass: "nqi--critical"  },
};

interface Props {
  peerConnection?: RTCPeerConnection | null;
}

const NetworkQualityIndicator: React.FC<Props> = ({ peerConnection }) => {
  const quality = useNetworkQuality(peerConnection);
  const cfg = LEVEL_CONFIG[quality.level];

  return (
    <div className={`nqi ${cfg.colorClass}`} role="status" aria-label={`Network: ${cfg.label}`}>
      <div className="nqi__bars" aria-hidden="true">
        {Array.from({ length: TOTAL_BARS }, (_, i) => (
          <div
            key={i}
            className={`nqi__bar${i < cfg.activeBars ? " nqi__bar--active" : ""}`}
            style={{ height: `${30 + i * 17.5}%` }}
          />
        ))}
      </div>
      <span className="nqi__label">{cfg.label}</span>
    </div>
  );
};

export { NetworkQualityIndicator };
export default NetworkQualityIndicator;
